// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"43f6e50c","178":"17f08df0","291":"e61da748","449":"e37d0765","499":"d4b017c2","511":"a54df0f3","571":"5c1cfd38","755":"81f5e514","841":"237ed23e","956":"df0959f2"}[chunkId] + ".chunk.js";
};